export default __webpack_public_path__ + "static/media/kub-mob1.b63d1e1c.svg";